import React, { useEffect } from "react";

import { useParams } from "react-router-dom";

import { selectFeatureObservabilitySuiteIntegrationsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { initForm } from "Reducers/integration";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import { useObservabilitySuiteIntegrationList } from "./config";
import { observabilitySuitIntegrationForms } from "./helper";
import IntegrationForm from "./IntegrationForm";
import { IntegrationFormProps } from "./type";

const Pages = (props: IntegrationFormProps) => {
  const type = useParams<{ type: string }>().type;
  const dispatch = useAppDispatch();
  const obsIntegrationFlagEnabled = useAppSelector(
    selectFeatureObservabilitySuiteIntegrationsEnabled
  );
  const { getIntegrationEnabled } = useObservabilitySuiteIntegrationList();
  useEffect(() => {
    dispatch(initForm({ id: props?.integration?.id }));
  }, [dispatch, props?.integration?.id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ObservabilityForm =
    observabilitySuitIntegrationForms[props.integration?.type || type || ""];

  return ObservabilityForm &&
    obsIntegrationFlagEnabled &&
    getIntegrationEnabled(props.integration?.type || type) ? (
    <ObservabilityForm {...props} />
  ) : (
    <IntegrationForm {...props} />
  );
};

export default Pages;
